"use client";
import { Container, Grid, Skeleton } from "@mantine/core";
import React from "react";

const PartnersSkeleton = () => {
  return (
    <div className="bg-brandGrey">
      <Container className="pb-16 pt-16">
        <Grid justify={"center"} align={"center"}>
          <Grid.Col md={7} sm={12}>
            <Skeleton height={30} width={80} />
            <Skeleton height={70} className="max-w-[663px]" mt={4} />
            <Skeleton height={75} className="max-w-[663px]" my={2} />
            <Skeleton height={50} width={170} mt={4} />
          </Grid.Col>
          <Grid.Col md={5} sm={12}>
            <Grid>
              {Array.from(Array(8)).map((item, index) => (
                <Grid.Col span={6} sm={6} md={6} lg={6} key={index}>
                  <div className="flex justify-center p-0">
                    <Skeleton height={100} width={224} />
                  </div>
                </Grid.Col>
              ))}
            </Grid>
          </Grid.Col>
        </Grid>
      </Container>
    </div>
  );
};

export default PartnersSkeleton;
